import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class UsageEntryItem  {
    _originalTypeClassName = "zvelton_Backoffice.BO.UsageEntryItem";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
UsageEntryItem.translate = translateService;
}
this.Id = null;
this.LLMCost = null;
this.Service_ToolCalls = null;
this.Service_TotalTokens = null;
this.Service_CompletionTokens = null;
this.Service_PromptTokens = null;
this.Service_ReasoningTokens = null;
this.Service_PromptTokensCached = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
LLMCost:any;
Service_ToolCalls:any;
Service_TotalTokens:any;
Service_CompletionTokens:any;
Service_PromptTokens:any;
Service_ReasoningTokens:any;
Service_PromptTokensCached:any;
LLMOption:any;
static setLLMOption = ($this, value) => {
var oldValue = $this.LLMOption;
$this.LLMOption = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}